document.addEventListener("turbolinks:load", function() {

  $('#collapseBorder').click(function (event){
    $(this).parent().toggleClass("border-right-0")
  });

  $('#applyTimeslots').click(function (event){
    event.preventDefault();

    num_guests = $('#num_reservations').val()
    timeslot = $('#timeslot_schedule_select').val()

    if (num_guests < 0) {
      alert("You must choose a value of zero or greater.")
      num_guests = $('#num_reservations').val(0)
      return false
    }

    switch(timeslot) {
      case "all":
        $(".num-guests").val(num_guests);
        break;
      case "00":
        $('.num-guests.00').val(num_guests);
        break;
      case "15":
        $('.num-guests.15').val(num_guests);
        break;
      case "30":
        $('.num-guests.30').val(num_guests);
        break;
      case "45":
        $('.num-guests.45').val(num_guests);
        break;
      default:
        $(".num-guests").val(0);
    }
  });

});
